/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener
 * crm-screener
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { PccPendingPatient } from './PccPendingPatient';
import {
    PccPendingPatientFromJSON,
    PccPendingPatientFromJSONTyped,
    PccPendingPatientToJSON,
} from './PccPendingPatient';

/**
 * 
 * @export
 * @interface FindOnePccPendingPatient200Response
 */
export interface FindOnePccPendingPatient200Response {
    /**
     * 
     * @type {PccPendingPatient}
     * @memberof FindOnePccPendingPatient200Response
     */
    data?: PccPendingPatient;
}

/**
 * Check if a given object implements the FindOnePccPendingPatient200Response interface.
 */
export function instanceOfFindOnePccPendingPatient200Response(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function FindOnePccPendingPatient200ResponseFromJSON(json: any): FindOnePccPendingPatient200Response {
    return FindOnePccPendingPatient200ResponseFromJSONTyped(json, false);
}

export function FindOnePccPendingPatient200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): FindOnePccPendingPatient200Response {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': !exists(json, 'data') ? undefined : PccPendingPatientFromJSON(json['data']),
    };
}

export function FindOnePccPendingPatient200ResponseToJSON(value?: FindOnePccPendingPatient200Response | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': PccPendingPatientToJSON(value.data),
    };
}

